/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

// Material Dashboard 2 PRO React TS components
import { BitacoraCotizacion } from "modules/bitacoraCotizacion";
import { GestionCotizacionContenido } from "modules/gestionCotizacion";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import ModalComponent from "components/Modal";
import { Backdrop, Card, CardContent, CircularProgress, Grid, Typography } from "@mui/material";
import { useCotizaciones } from "hooks/useCotizaciones";
import CotizacionesModulo from "components/VistaModulos/CotizacionesModulo";

function Cotizaciones(): JSX.Element {
  const {
    procesando,
    isAlertOpen,
    mensajeAlert,
    handleisAlertClose,
    cotizaciones,
    isAlertOpenDetalleCotizacion,
    handleisAlertOpenDetalleCotizacion,
    handleisAlertCloseDetalleCotizacion,
    abrirBitacora,
    idCotizacionBitacora,
    cerrarBitacora,
    gestion,
  } = useCotizaciones();

  return (
    <DashboardLayout>
      <MDBox py={2}>
        <Card>
          <CardContent>
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              sx={{ height: "100%", mt: 1 }}
            >
              <Typography variant="h4" gutterBottom>
                Cotizaciones
              </Typography>
            </Grid>
            <Grid>
              <CotizacionesModulo
                verCotizaciones={cotizaciones}
                procesando={procesando}
                handleisAlertOpenDetalleCotizacion={handleisAlertOpenDetalleCotizacion}
                onVerBitacora={abrirBitacora}
                getCotizacionPorId={(datos: any) => gestion.cargarCotizacion(datos.id_cotizacion)}
              />
            </Grid>
          </CardContent>
        </Card>
      </MDBox>

      {/*<Footer />*/}
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={procesando}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {/* MODAL PARA VER LA BITÁCORA DE LA COTIZACIÓN */}
      <ModalComponent
        esFullScreen
        handleClose={cerrarBitacora}
        isOpen={idCotizacionBitacora !== null}
        key={"alerta-bitacora-cotizacion"}
        textoHeader={`Bitácora - Cotización #${idCotizacionBitacora ?? ""}`}
      >
        <Grid container spacing={2} style={{ textAlign: "center" }}>
          <Grid item xs={12}>
            <br />
            {idCotizacionBitacora !== null && (
              <BitacoraCotizacion
                id_cotizacion={idCotizacionBitacora}
                folio={`#${idCotizacionBitacora}`}
              />
            )}
          </Grid>
        </Grid>
      </ModalComponent>
      {/* MODAL PARA VER DETALLES DE COTIZACION */}
      <ModalComponent
        esFullScreen
        handleClose={handleisAlertCloseDetalleCotizacion}
        isOpen={isAlertOpenDetalleCotizacion}
        key={"alerta-detalles"}
        procesando={gestion.procesando}
        textoHeader={`Cotización #${gestion.cotizacion?.id ?? ""} - Requisición: ${gestion.cotizacion?.requisicion ?? ""}`}
        actions={gestion.acciones}
      >
        <Grid container spacing={2} style={{ textAlign: "center" }}>
          <Grid item xs={12}>
            <br />
            <br />
            <GestionCotizacionContenido gestion={gestion} />
          </Grid>
        </Grid>
      </ModalComponent>
      <ModalComponent handleClose={handleisAlertClose} isOpen={isAlertOpen} key={"alerta"}>
        <Grid container spacing={2} style={{ textAlign: "center" }}>
          <Grid item xs={12}>
            <br />
            <br />
            <p>{mensajeAlert}</p>
          </Grid>
        </Grid>
      </ModalComponent>
    </DashboardLayout>
  );
}

export default Cotizaciones;
